import React, { Component } from "react";
import { Wrapper } from "./InputErrorWrap.style";

/**
 * @component
 * @example
 * // Example usage:
 * <InputErrorMsgWrapper isError={hasError} message="Please enter a valid value.">
 *   <input type="text" name="example" />
 * </InputErrorMsgWrapper>
 *
 * @param {React.ReactNode} children
 * @param {boolean} isError
 * @param {string} message
 */
class InputErrorMsgWrapper extends Component {
  render() {
    const { children, isError, message = "" } = this.props;
    return (
      <Wrapper $isError={isError}>
        {children}
        {isError && <span className="valid-error">{message}</span>}
      </Wrapper>
    );
  }
}

export default InputErrorMsgWrapper;
